<template>

  <div class="container">

    <div v-if="response.material">
      <div v-if="response.material.tipus == 'material' && response.material.activitat_comunitat">
        <ActivitatMaterialUPCommonsView :material="response.material"></ActivitatMaterialUPCommonsView>
      </div>

      <div v-else-if="response.material.tipus == 'material' &&
            (response.material.subtipus == 'autoriaLlibre' ||
              response.material.subtipus == 'autoriaCapitolLlibre' ||
              response.material.subtipus == 'autoriaSoftware' ||
              response.material.subtipus == 'autoriaCapitolCatalegExposicio' ||
              response.material.subtipus == 'edicioCatalegExposicio')">
        <ActivitatMaterialView :material="response.material"></ActivitatMaterialView>
      </div>

      <div v-else-if="response.material.tipus == 'activitat' && response.material.activitat_comunitat">
        <ActivitatMaterialUPCommonsView :material="response.material"></ActivitatMaterialUPCommonsView>
      </div>

      <!-- estada Centre RDI -->
      <div v-else-if="response.material.tipus == 'activitat' && response.material.activitat_subtipus == 'docencia'">
        <ActivitatEstadaCentreView :material="response.material"></ActivitatEstadaCentreView>
      </div>

      <div v-else-if="response.material.tipus == 'activitat' && response.material.activitat_subtipus == 'formacio'">
        <ActivitatFormacioView :material="response.material"></ActivitatFormacioView>
      </div>

      <div v-else-if="response.material.tipus == 'activitat' && response.material.activitat_subtipus == 'innovacio'">
        <ActivitatInnovacioView :material="response.material"></ActivitatInnovacioView>
      </div>

      <div v-else-if="response.material.tipus == 'activitat' && response.material.activitat_subtipus == 'tutoria'">
        <ActivitatTutoriaView :material="response.material"></ActivitatTutoriaView>
      </div>

      <div v-else-if="response.material.tipus == 'activitat' && response.material.activitat_subtipus == 'premis'">
          <ActivitatPremisView :material="response.material"></ActivitatPremisView>
      </div>


      <!--div v-if="response.material" class="alert alert-danger mt-5" role="alert">
        <span class="badge bg-danger" >MaterialView</span>
        <span v-if="response.material.activitat_subtipus == 'innovacio'" class="badge bg-warning" >ActivitatInnovacioView</span>
        Tipus: <b class="me-5">{{response.material.tipus}}</b>  Activitat_subtipus: <b>{{response.material.activitat_subtipus}}</b>
        <hr>
        <pre>{{ JSON.stringify(response.material, null, 4) }}</pre>
      </div-->

    </div>

  </div>

</template>

<script>

import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import store from "@/store";
import MaterialService from "@/services/MaterialService";
import {imageUrlAlt} from "@/utils/utils";
import ActivitatMaterialView from "@/views/activitats/ActivitatMaterialView.vue";
import ActivitatInnovacioView from "@/views/activitats/ActivitatInnovacioView.vue";
import ActivitatMaterialUPCommonsView from "@/views/activitats/ActivitatMaterialUPCommonsView.vue";
import ActivitatFormacioView from "@/views/activitats/ActivitatFormacioView.vue";
import ActivitatTutoriaView from "@/views/activitats/ActivitatTutoriaView.vue";
import ActivitatEstadaCentreView from "@/views/activitats/ActivitatEstadaCentreView.vue";
import ActivitatPremisView from "@/views/activitats/ActivitatPremisView.vue";
import {setMetadataName} from "@/composables/metadataFunctions";

  export default {
    name: "ProfessorsView",
    methods: {imageUrlAlt},
    components: {
      ActivitatTutoriaView, ActivitatEstadaCentreView, ActivitatPremisView,
      ActivitatFormacioView, ActivitatMaterialUPCommonsView, ActivitatInnovacioView, ActivitatMaterialView},

    setup() {
      const response = ref([]);
      const responseMaterials = ref([]);
      const route = useRoute();

      const totalElements = ref(0)
      const pageSize = computed(() => { return store.getters.pageSize})
      const selectedOrder = ref("data desc, activitat_data_available desc");

      onMounted(async () => {

        const id = route.params.id;
        response.value = await MaterialService.getMaterial(id)
        await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-brown.webp') });
        setMetadataName(response.value.material.activitat_titol)
      });

      return {
        response,
        responseMaterials,

        selectedOrder,
        totalElements,
        pageSize
      }
    }
  }

</script>

<style scoped>
.card-body {
  position: relative;
  padding: 1.5rem; /* Optional: Adjust padding */
  color: #636363;
}

.card-body::before {
  content: "";
  position: absolute;
  top: 15px; /* Add margin from the top */
  right: 15px; /* Add margin from the right */
  bottom: 15px; /* Add margin from the bottom */
  left: auto; /* Add margin from the left */
  width: calc(50% - 25px); /* Occupies half of the card body minus the margins */
  height: calc(100% - 25px); /* Occupies full height minus the margins */
  background: url('../assets/images/fons_fitxa.png') no-repeat right center; /* Aligns background image to the right */
  background-size: contain;
  opacity: 0.8; /* Adjust the transparency as needed */
  z-index: 1;
}

.card-body * {
  position: relative;
  z-index: 2;
}

</style>
